'use client';

import { Award, Crown } from 'lucide-react';

type Tier = 'none' | 'bronze' | 'silver' | 'gold' | 'platinum' | string;

const LABELS: Record<string, string> = {
  bronze: 'Bronze',
  silver: 'Silver',
  gold: 'Gold',
  platinum: 'Platinum',
};

// Tailwind palette tokens per merged plan W6.4 spec.
const STYLES: Record<string, string> = {
  bronze:   'bg-amber-700/15 text-amber-700 dark:text-amber-400',
  silver:   'bg-zinc-400/20 text-zinc-700 dark:text-zinc-300',
  gold:     'bg-amber-400/20 text-amber-700 dark:text-amber-300',
  platinum: 'bg-violet-500/15 text-violet-700 dark:text-violet-300',
};

export default function TierBadge({ tier, className = '' }: { tier: Tier; className?: string }) {
  if (!tier || tier === 'none') return null;
  const label = LABELS[tier] ?? tier;
  const style = STYLES[tier] ?? STYLES.bronze;
  const Icon = tier === 'platinum' ? Crown : Award;
  return (
    <span
      title={`${label} tier`}
      className={
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ' +
        style + ' ' + className
      }
    >
      <Icon className="h-3.5 w-3.5" strokeWidth={1.75} />
      {label}
    </span>
  );
}
